import { useCardRenderStarted as useCardRenderStartedInternal, useCardRenderMarkers as useCardRenderMarkersInternal } from '../internal/perf/cardPerfHooks';
export const useCardRenderStarted = useCardRenderStartedInternal;
export const useCardRenderMarkers = useCardRenderMarkersInternal;